// UI copy only — product/category/client names, descriptions, specs,
// and site settings (phone, email, address, about text) are admin-entered
// business content and are intentionally never translated here.
const translations = {
  en: {
    nav: { home: 'HOME', companyInfo: 'COMPANY INFO', products: 'PRODUCTS', brands: 'BRANDS', clients: 'CLIENTS', careers: 'CAREERS', promotional: 'PROMOTIONAL', contact: 'CONTACT', discover: 'DISCOVER', recruit: 'Recruitment', inquiry: 'Inquiry', menu: 'MENU', close: 'CLOSE' },

    common: {
      home: 'Home',
      companyInfo: 'Company Info',
      products: 'Products',
      brands: 'Brands',
      clients: 'Clients',
      careers: 'Careers',
      promotional: 'Promotional',
      contactUs: 'Contact Us',
      viewAll: 'View All',
      viewDetails: 'View Details',
      viewProducts: 'View Products',
      readMore: 'Read More',
      backTo: 'Back to',
      cantFindTitle: "Can't find what you're looking for?",
      cantFindSubtitle: 'We carry many more products. Contact us with your requirements.',
      pleaseContact: 'Please contact us to inquire about available products.',
      specifications: 'Specifications',
      browseBy: 'Browse By',
      brand: 'Brand',
      client: 'Client',
      visitWebsite: 'Visit Website',
    },

    footer: {
      tagline: 'A Japanese Trading company based in Philippines providing precision machinery & measuring equipment solutions.',
      quickLinks: 'Quick Links',
      allRightsReserved: 'All Rights Reserved.',
    },

    home: {
      heroFallbackTitle: 'Opening New Doors for Manufacturing',
      heroFallbackSubtitle: 'MONODUKURI',
      aboutUs: 'About Us',
      stat1: 'Years of Excellence',
      stat2: 'Established in Philippines',
      stat3: 'Products Available',
      stat4: 'Major Clients',
      whatWeOffer: 'What We Offer',
      productCategories: 'Product Categories',
      viewAllProducts: 'View All Products',
      ourPartners: 'Our Partners',
      clientsHeading: 'Clients',
      ctaTitle: 'Ready to Solve Your Manufacturing Issues?',
      ctaSubtitle: 'Contact us today to discuss your needs and find the right solution.',
      getInTouch: 'Get In Touch',
      newsSub: 'Latest news & promotions',
      allNews: 'ALL NEWS',
      aboutSub: 'About Sankyo',
      productsSub: 'Products we handle',
      allProducts: 'ALL PRODUCTS',
      productsIntro: "From measurement to cutting tools and factory equipment, we draw on Sankyo Seiki's wide network to deliver the right solution for every manufacturing site.",
      clientsSub: 'Our client partners',
      allClients: 'ALL CLIENTS',
      recruitText: 'We are looking for people to grow with us.',
      recruitButton: 'View open positions',
      contactSub: 'Contact form',
      contactText: 'For questions about our products, services or anything else, please feel free to contact us.',
      contactButton: 'CONTACT',
      detail: 'DETAIL',
    },

    products: {
      browseByCategory: 'Browse by Category',
      productCategories: 'Product Categories',
      noBrands: 'No brands found in this category yet.',
      noProducts: 'No products found for this brand in this category yet.',
    },

    brands: {
      eyebrow: 'What We Carry',
      title: 'Our Brands',
      intro: 'The brands Sankyo represents, organized by product line.',
      empty: 'No brands have been added yet.',
      other: 'Other',
      notFound: 'This brand could not be found.',
      backToBrands: 'Back to Brands',
      byCategory: 'Search by category',
      byAlpha: 'Search in alphabetical order',
      byName: 'Search by company name',
      searchLabel: 'Enter a company name',
      searchPlaceholder: 'Manufacturer / company name',
      noResults: 'No brands match your search.',
      categories: 'Categories',
      subcategories: 'Sub Categories',
      interestedIn: 'Interested in {name}?',
      contactPrompt: 'Tell us what you need and our team will get back to you with details and a quotation.',
    },

    clients: {
      title: 'Client Partners',
      notFound: 'Client not found.',
      backToClients: 'Back to Clients',
      enquireAboutProducts: 'Enquire About Products',
    },

    product: {
      notFoundTitle: 'Product Not Found',
      notFoundMessage: 'This product could not be found.',
      backToProducts: 'Back to Products',
      enquireAboutThisProduct: 'Enquire About This Product',
      view: 'view',
      views: 'views',
    },

    contact: {
      title: 'Contact Us',
      eyebrow: 'Get In Touch',
      heading: 'Contact Information',
      intro: 'Feel free to reach out to us with any enquiries about our products or services. Our team will respond promptly.',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      viewOnMap: 'View on Google Maps',
      sendMessage: 'Send Us a Message',
      fullName: 'Full Name',
      emailAddress: 'Email Address',
      phoneNumber: 'Phone Number',
      company: 'Company',
      pezaType: 'PEZA Enterprise Type',
      inquiryAbout: 'Inquiry about:',
      message: 'Message',
      attachImages: 'Attach Images (optional)',
      addImage: 'Add',
      attachImagesHint: 'Up to 3 images, 5MB each.',
      tooManyFiles: 'You can attach up to {max} images.',
      fileTooLarge: 'Each image must be 5MB or smaller.',
      send: 'Send Message',
      sending: 'Sending...',
      successTitle: 'Message Sent Successfully!',
      successMessage: "Thank you for contacting us. We'll get back to you shortly.",
      sendAnother: 'Send Another Message',
      error: 'Something went wrong. Please try again.',
    },

    careers: {
      title: 'Careers',
      tagline: 'Be a Sankyo associate and build your career with us.',
      eyebrow: 'Join Our Team',
      defaultTitle: 'Build Your Career With Us',
      defaultIntro: "We're always looking for talented people to join our team. Explore our current openings below.",
      joinTeam: 'Join Our Team',
      openPositions: 'Open Positions',
      explore: 'Explore',
      noOpenings: 'No open positions right now — check back soon.',
      requirements: 'Qualifications',
      overview: 'Job Overview',
      codeNumber: 'Code Number',
      apply: 'Apply',
      firstName: 'First Name',
      lastName: 'Last Name',
      mobileNumber: 'Mobile Number',
      email: 'Email',
      uploadResume: 'Upload Resume',
      consentText: 'I have read and agreed to have my information processed for recruitment purposes.',
      submit: 'Submit',
      submitting: 'Submitting...',
      applySuccessTitle: 'Application Submitted!',
      applySuccessMessage: "Thank you for applying. We'll review your application and get back to you.",
      applyError: 'Something went wrong. Please try again.',
      applyNow: 'Apply Now',
      backToCareers: 'Back to Careers',
      notFoundTitle: 'Position Not Found',
      notFoundMessage: 'This job opening could not be found.',
    },

    promotions: {
      title: 'Promotional',
      tab_all: 'All',
      tab_highlight: 'Highlights',
      tab_announcement: 'Announcements',
      tab_event: 'Events',
      empty: 'Nothing posted yet — check back soon.',
      backToPromotions: 'Back to Promotional',
      notFoundTitle: 'Post Not Found',
      notFoundMessage: 'This post could not be found.',
    },

    companyInfo: {
      title: 'Company Info',
      eyebrow: 'About the Company',
      missionTitle: 'Our Mission',
      missionText: 'While maintaining our performance in domestic procurement and sales of high-quality service and products, we wish to build long-term relationships with all our clients in Philippines and Southeast Asia, with the theme of "Solving Manufacturing Issues".',
      brandsTitle: 'Our Brands',
      detailsTitle: 'Company Details',
      established: 'Established',
      parentCompany: 'Parent Company',
      headquarters: 'Headquarters',
      specialization: 'Specialization',
      specializationValue: 'Precision Machinery & Measuring Equipment',
      region: 'Region',
      regionValue: 'Philippines & South-East Asia',
      contactInfo: 'Contact Information',
    },
  },

  ja: {
    nav: { home: 'ホーム', companyInfo: '会社情報', products: '製品', brands: 'ブランド', clients: '取引先', careers: '採用情報', promotional: 'お知らせ', contact: 'お問い合わせ', discover: 'ディスカバー', recruit: '採用情報', inquiry: 'お問い合わせ', menu: 'MENU', close: 'CLOSE' },

    common: {
      home: 'ホーム',
      companyInfo: '会社情報',
      products: '製品',
      brands: 'ブランド',
      clients: '取引先',
      careers: '採用情報',
      promotional: 'お知らせ',
      contactUs: 'お問い合わせ',
      viewAll: 'すべて見る',
      viewDetails: '詳細を見る',
      viewProducts: '製品を見る',
      readMore: '続きを読む',
      backTo: '戻る:',
      cantFindTitle: 'お探しの製品が見つかりませんか?',
      cantFindSubtitle: '他にも多数の製品を取り扱っております。お気軽にお問い合わせください。',
      pleaseContact: '取り扱い製品についてはお問い合わせください。',
      specifications: '仕様',
      browseBy: '絞り込み',
      brand: 'ブランド',
      client: '取引先',
      visitWebsite: 'ウェブサイトを見る',
    },

    footer: {
      tagline: 'フィリピンを拠点とする日系商社として、精密機械・計測機器のソリューションを提供しています。',
      quickLinks: 'クイックリンク',
      allRightsReserved: '無断複写・転載を禁じます。',
    },

    home: {
      heroFallbackTitle: 'ものづくりの新たな扉を開く',
      heroFallbackSubtitle: 'MONODUKURI',
      aboutUs: '会社概要',
      stat1: '年の実績',
      stat2: 'フィリピン設立',
      stat3: '取扱製品数',
      stat4: '主要取引先数',
      whatWeOffer: '事業内容',
      productCategories: '製品カテゴリー',
      viewAllProducts: 'すべての製品を見る',
      ourPartners: 'パートナー企業',
      clientsHeading: '取引先',
      ctaTitle: '製造現場の課題を解決しませんか?',
      ctaSubtitle: 'お客様のニーズに合わせた最適なソリューションをご提案します。',
      getInTouch: 'お問い合わせ',
      newsSub: '最新のお知らせ',
      allNews: 'ALL NEWS',
      aboutSub: '三共について',
      productsSub: '取扱商品',
      allProducts: 'ALL PRODUCTS',
      productsIntro: '計測機器から切削工具、工場設備まで、三共精機の幅広いネットワークを活かし、製造現場に最適なソリューションをお届けします。',
      clientsSub: '取引先パートナー',
      allClients: 'ALL CLIENTS',
      recruitText: '三共では共に働く仲間を募集しております。',
      recruitButton: '募集職種を見る',
      contactSub: 'お問い合わせフォーム',
      contactText: '取扱商品・サービスに関するご相談など、お気軽にお問い合わせください。',
      contactButton: 'CONTACT',
      detail: 'DETAIL',
    },

    products: {
      browseByCategory: 'カテゴリーから探す',
      productCategories: '製品カテゴリー',
      noBrands: 'このカテゴリーにはまだブランドが登録されていません。',
      noProducts: 'このブランド・カテゴリーの組み合わせにはまだ製品がありません。',
    },

    brands: {
      eyebrow: '取扱ブランド',
      title: 'ブランド一覧',
      intro: '三共が取り扱うブランドを、製品ラインごとにご紹介します。',
      empty: 'まだブランドが登録されていません。',
      other: 'その他',
      notFound: 'このブランドは見つかりませんでした。',
      backToBrands: 'ブランド一覧に戻る',
      byCategory: 'カテゴリーから探す',
      byAlpha: '五十音・アルファベット順から探す',
      byName: '会社名から探す',
      searchLabel: '会社名を入力してください',
      searchPlaceholder: 'メーカー名・会社名',
      noResults: '該当するブランドが見つかりませんでした。',
      categories: 'カテゴリー',
      subcategories: 'サブカテゴリー',
      interestedIn: '{name}についてのお問い合わせ',
      contactPrompt: 'ご要望をお知らせください。担当者より詳細とお見積りをご連絡いたします。',
    },

    clients: {
      title: '取引先パートナー',
      notFound: '取引先が見つかりませんでした。',
      backToClients: '取引先一覧に戻る',
      enquireAboutProducts: '製品についてお問い合わせ',
    },

    product: {
      notFoundTitle: '製品が見つかりません',
      notFoundMessage: 'この製品は見つかりませんでした。',
      backToProducts: '製品一覧に戻る',
      enquireAboutThisProduct: 'この製品についてお問い合わせ',
      view: '閲覧',
      views: '閲覧',
    },

    contact: {
      title: 'お問い合わせ',
      eyebrow: 'お問い合わせ',
      heading: '連絡先情報',
      intro: '製品やサービスに関するお問い合わせは、お気軽にご連絡ください。担当者より迅速にご返信いたします。',
      phone: '電話番号',
      email: 'メールアドレス',
      address: '所在地',
      viewOnMap: 'Google マップで見る',
      sendMessage: 'メッセージを送信',
      fullName: 'お名前',
      emailAddress: 'メールアドレス',
      phoneNumber: '電話番号',
      company: '会社名',
      pezaType: 'PEZA登録企業区分',
      inquiryAbout: 'お問い合わせ内容:',
      message: 'メッセージ',
      attachImages: '画像を添付（任意）',
      addImage: '追加',
      attachImagesHint: '最大3枚、各5MBまで。',
      tooManyFiles: '添付できる画像は最大{max}枚です。',
      fileTooLarge: '各画像は5MB以下にしてください。',
      send: '送信する',
      sending: '送信中...',
      successTitle: '送信が完了しました!',
      successMessage: 'お問い合わせいただきありがとうございます。担当者より折り返しご連絡いたします。',
      sendAnother: '別のメッセージを送る',
      error: 'エラーが発生しました。もう一度お試しください。',
    },

    careers: {
      title: '採用情報',
      tagline: '三共の一員として、キャリアを築きませんか。',
      eyebrow: '一緒に働きませんか',
      defaultTitle: 'キャリアを築く',
      defaultIntro: '私たちは常に有能な人材を求めています。現在の募集職種をご覧ください。',
      joinTeam: '仲間になりませんか',
      openPositions: '募集中の職種',
      explore: '詳細を見る',
      noOpenings: '現在募集中の職種はありません。またご確認ください。',
      requirements: '応募資格',
      overview: '職務内容',
      codeNumber: '求人コード',
      apply: '応募する',
      firstName: '名',
      lastName: '姓',
      mobileNumber: '携帯電話番号',
      email: 'メールアドレス',
      uploadResume: '履歴書をアップロード',
      consentText: '採用選考のために個人情報が処理されることに同意します。',
      submit: '送信する',
      submitting: '送信中...',
      applySuccessTitle: '応募が完了しました！',
      applySuccessMessage: 'ご応募ありがとうございます。内容を確認の上、ご連絡いたします。',
      applyError: 'エラーが発生しました。もう一度お試しください。',
      applyNow: '応募する',
      backToCareers: '採用情報に戻る',
      notFoundTitle: '求人が見つかりません',
      notFoundMessage: 'この求人は見つかりませんでした。',
    },

    promotions: {
      title: 'お知らせ',
      tab_all: 'すべて',
      tab_highlight: 'ハイライト',
      tab_announcement: 'お知らせ',
      tab_event: 'イベント',
      empty: 'まだ投稿がありません。またご確認ください。',
      backToPromotions: 'お知らせに戻る',
      notFoundTitle: '投稿が見つかりません',
      notFoundMessage: 'この投稿は見つかりませんでした。',
    },

    companyInfo: {
      title: '会社情報',
      eyebrow: '会社概要',
      missionTitle: '私たちの使命',
      missionText: '国内での調達・販売における高品質なサービスと製品の実績を維持しながら、「ものづくりの課題を解決する」というテーマのもと、フィリピンおよび東南アジアのすべての取引先との長期的な関係を築いていきたいと考えています。',
      brandsTitle: '取扱ブランド',
      detailsTitle: '会社概要',
      established: '設立',
      parentCompany: '親会社',
      headquarters: '本社',
      specialization: '事業分野',
      specializationValue: '精密機械・計測機器',
      region: '対応地域',
      regionValue: 'フィリピン・東南アジア',
      contactInfo: '連絡先情報',
    },
  },
};

export default translations;
